import { useField, useFormikContext } from 'formik';

import { MultiSelect } from '@/components/multiSelect/MultiSelect';
import type { TMultiSelectProps } from '@/components/multiSelect/types';

type TFormikMultiSelectProps = Omit<TMultiSelectProps, 'value' | 'onChange'> & { name: string };

export const FormikMultiSelect = ({ name, ...props }: TFormikMultiSelectProps) => {
  const [field, meta, helpers] = useField(name);
  const { submitCount } = useFormikContext();

  return (
    <MultiSelect
      value={field.value ?? []}
      onChange={(value) => helpers.setValue(value)}
      error={submitCount > 0 ? meta.error : undefined}
      {...props}
    />
  );
};
